import { styled } from '@mui/material'
import { gridClasses, GridEventListener } from '@mui/x-data-grid-pro'
import GenericTable from 'src/components/table/GenericTable'
import { IPosition } from 'src/generated-types'

export interface IPositionTable {
  customerId: EntityId
  localityId: EntityId
  mooringId: EntityId
  onRowClick?: GridEventListener<'rowClick'> | undefined
  isSelectable?: boolean
  positions: IPosition[]
  checkboxSelection?: boolean
  onColumnWidthsChange?: (widths: { widths: number[]; leftOffset: number }) => void
}

export const CustomStyledTable = styled(GenericTable)({
  '& .MuiDataGrid-columnHeaders': {
    display: 'none',
  },
  '& .MuiDataGrid-virtualScroller': {
    marginTop: '0 !important',
  },
  [`& .${gridClasses.row}.non-clickable-row`]: {
    cursor: 'default',
  },
  '.inner-table': {
    '& .MuiDataGrid-columnHeaders': {
      display: 'block',
    },
    '& .MuiDataGrid-virtualScroller': {
      marginTop: '40px !important',
    },
    [`& .${gridClasses.columnHeadersInner}`]: {
      lineHeight: '40px',
    },
  },
})
